import { useTranslation } from 'react-i18next';
import { useModal } from 'context/ModalContext';
import { useToast } from 'context/ToastContext';
import { getButtonsNoYesDanger } from 'context/helpers/helperModalContext';
import SvgTrash from 'components/svg/SvgTrash';

const useDeleteUser = () => {
    const { t } = useTranslation();
    const { showDlg } = useModal();
    const { showToast } = useToast();

    const deleteUser = (cbDeleteUser: () => void | Promise<void>) => {
        const paramsDelDlg = {
            buttons: [...getButtonsNoYesDanger(t)],
            type: 'confirm',
            text: (
                <h4 className="d-flex text-danger">
                    <SvgTrash className="text-danger" />
                    <span className="ps-2">{t('Users.deleteUser')}</span>
                </h4>
            ),
        };

        paramsDelDlg.buttons[1].handleClick = () => {
            showDlg(false);
            cbDeleteUser();
        };
        showDlg(paramsDelDlg);
    };

    return deleteUser;
};

export default useDeleteUser;
